import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { RouterModule } from "@angular/router";
import { SharedUiModule } from "@dtm-frontend/shared/ui";
import { LanguageCode, SharedI18nModule, getTranslocoInlineLoader } from "@dtm-frontend/shared/ui/i18n";
import { TRANSLOCO_SCOPE } from "@jsverse/transloco";
import { LetModule, PushModule } from "@ngrx/component";
import { NgxsModule } from "@ngxs/store";
import { TestComponent } from "./components/test/test.component";
import { HelpdeskToolkitRoutingModule } from "./helpdesk-toolkit-routing.module";
import { HelpdeskToolkitApiService } from "./services/helpdesk-toolkit-api.service";
import { HelpdeskToolkitState } from "./state/helpdesk-toolkit.state";

@NgModule({
    imports: [
        NgxsModule.forFeature([HelpdeskToolkitState]),
        CommonModule,
        HelpdeskToolkitRoutingModule,
        LetModule,
        MatInputModule,
        MatMenuModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        PushModule,
        ReactiveFormsModule,
        RouterModule,
        SharedI18nModule,
        SharedUiModule,
        MatProgressBarModule,
    ],
    declarations: [TestComponent],
    exports: [TestComponent],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            multi: true,
            useValue: {
                scope: "helpdeskToolkitLib",
                loader: getTranslocoInlineLoader((language: LanguageCode) => import(`../assets/i18n/${language}.json`)),
            },
        },
    ],
})
export class HelpdeskToolkitModule {
    public static forRoot(): ModuleWithProviders<HelpdeskToolkitModule> {
        return {
            ngModule: HelpdeskToolkitModule,
            providers: [
                {
                    provide: HelpdeskToolkitApiService,
                    useClass: HelpdeskToolkitApiService,
                },
            ],
        };
    }

    public static forTest(): ModuleWithProviders<HelpdeskToolkitModule> {
        return {
            ngModule: HelpdeskToolkitModule,
            providers: [
                {
                    provide: HelpdeskToolkitApiService,
                    useValue: null,
                },
            ],
        };
    }
}
